import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-78f004b5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "inner-container" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 2,
  class: "check-luggage"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseAlert = _resolveComponent("BaseAlert")!
  const _component_BookingExtraTermsCheckbox = _resolveComponent("BookingExtraTermsCheckbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.innerSections, (section, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass([_ctx.innerSections && _ctx.innerSections.length > 1 && !_ctx.isParking ? 'col--12 col-md--6' : 'col--12']),
        key: index
      }, [
        _createElementVNode("div", _hoisted_2, [
          (section.content)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "xhtml",
                innerHTML: section.content
              }, null, 8, _hoisted_3))
            : _createCommentVNode("", true),
          (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.componentName), {
            section: section,
            direction: _ctx.getDirection(section, index),
            componentIndex: _ctx.componentIndex
          }, null, 8, ["section", "direction", "componentIndex"])),
          (section.footer && _ctx.ifExtraLuggage !== true)
            ? (_openBlock(), _createBlock(_component_BaseAlert, {
                key: 1,
                type: "info"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    innerHTML: section.footer
                  }, null, 8, _hoisted_4)
                ]),
                _: 2
              }, 1024))
            : _createCommentVNode("", true),
          (_ctx.ifExtraLuggage !== true && section.footer)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_component_BookingExtraTermsCheckbox, {
                  label: "I don't have any excess luggage",
                  identifier: _ctx.TermTypeEnum[_ctx.TermTypeEnum.ExcessLuggage]
                }, null, 8, ["identifier"])
              ]))
            : _createCommentVNode("", true)
        ])
      ], 2))
    }), 128))
  ]))
}